module.exports = __webpack_public_path__ + "img/1.a3295b27.jpg";